import React, { useState } from "react";


import API from '../../tools/API';
import style from './Modal.module.scss';

interface UpsertPoll {
    openModal: (arg: boolean) => void;
    pollId: string | undefined;
    optionId: number;
    numberOfVotes: number;
}

const UpsertPollModal: React.FC<UpsertPoll> = ({ openModal, pollId, optionId, numberOfVotes }) => {
    const [noOfVotes, setNoOfVotes] = useState(numberOfVotes);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const changeNumberOfVotes = () => {
        API.upsertCustomResult(Number(pollId), optionId, noOfVotes)
            .then(res => {
                openModal(false);
                setLoading(false);
                window.location.reload();
            })
            .catch(err => {
                setLoading(false);
                setError(err.response.data.Exception);
            })
    }

    return (
        <div className={style.AddCathegory}>
            <h2 className={style.AddCathegory__title} >Zmień liczbę głosów</h2>
            <form className={style.AddCathegory__form}>
                <label
                    htmlFor="noOfVotes"
                    className={style.AddCathegory__formLabelNumber}
                >
                    Liczba głosów:
                </label>
                <input
                    type="number"
                    id="noOfVotes"
                    className={style.AddCathegory__formInput}
                    value={noOfVotes}
                    onChange={(e) => {
                        setNoOfVotes(parseInt(e.target.value))
                    }}
                />
                {!loading ? <input
                    type="button"
                    value="ZMIEŃ"
                    className={style.AddCathegory__button}
                    onClick={(e) => {
                        e.preventDefault();
                        setLoading(true);
                        changeNumberOfVotes();
                    }}
                /> : <p className={style.loader}>Trwa dodawanie...</p>
                }
                {error &&
                    <div className={style.addPoll__row}>
                        <p className={style.errorText}>{error}</p>
                    </div>
                }
            </form>
        </div>
    )
}

export default UpsertPollModal;